export default __webpack_public_path__ + "f96458c87e8ff1d9cdd4eec4d3805dde.svg";